import React from 'react';
import { preventMouseMove } from '../../../helpers/events';
import useViewModeToggle from '../../../hooks/useViewModeToggle';
import ViewModeToggleStyles from './styles';
import { sendGoal } from '../../../helpers/metrika';
import GOALS from '../../../constants/GOALS';

interface ViewModeToggleProps {
  spaceRight?: boolean;
}

const ViewModeToggle = ({ spaceRight }: ViewModeToggleProps) => {
  const { Widget } = window;
  const { toggle, t, basketSize } = useViewModeToggle();

  const handleToggle = () => {
    toggle();
    sendGoal(GOALS.TABLE_MODE);
  };

  return (
    <ViewModeToggleStyles.Button
      widthAuto
      spaceRight={spaceRight}
      offset={basketSize}
      onMouseMove={preventMouseMove}
      onClick={handleToggle}
      data-selenium="table-toggle"
    >
      <ViewModeToggleStyles.Inner>
        {Widget.schemeMode ? t('table') : t('scheme')}
      </ViewModeToggleStyles.Inner>
    </ViewModeToggleStyles.Button>
  );
};

export default ViewModeToggle;
